<div *ngIf="!isDivContent" class="detials-note-text flex flex-col justify-start items-start">
    @if (helpNoteItem && helpNoteItem.notes && helpNoteItem.notes.length > 0) {
    <ul>
      <li
        *ngFor="let note of helpNoteItem.notes"
        [innerHTML]="note | sanitizeHtml"
      ></li>
    </ul>
    } @else {
    <div class="no-data ">
      <i class="fal fa-info-circle k-mr-2"></i>
      <span>No details available</span>
    </div>
    }
</div>
<div *ngIf="isDivContent" class="detials-note-text flex flex-col justify-start items-start">
    @if (divContent.length > 0) {
    <div
        class="view-details "
        [innerHTML]="divContent | sanitizeHtml"
      ></div>
    } @else {
    <div class="no-data">
      <i class="fal fa-info-circle k-mr-2 m-r-4"></i>
      <span>No details available</span>
    </div>
    }
</div>
